$(document).ready(function () {
	$('[data-trigger-product-zoom]').click(function (event) {
		event.preventDefault();
		var targetSlide = $(this).data('trigger-product-zoom');
		var $productZoom = $('.product-zoom');
		var $productZoomClose = $productZoom.find('.product-zoom__close');
		var activeClass = 'product-zoom--active';
		var scrollLockClass = 'scroll-lock';

		$productZoom.css('top', $(window).scrollTop());

		// Open overlay + prevent scrolling on body
		$productZoom.addClass(activeClass);
		$('body').addClass(scrollLockClass);

		var $productZoomImages = $('.product-zoom__images');
		var $productZoomThumbnailsCarousel = $(
			'.product-zoom__thumbnails-carousel'
		);

		// Handle init zoom functionality
		var initZoom = function (event, slick) {
			var $currentImage = $productZoomImages.find(
				'.slick-current .product-zoom__image'
			);

			$currentImage.trigger('zoom.destroy');
			$currentImage.zoom({
				url: $currentImage.data('raw'),
			});
		};

		// Trigger init zoom functionality
		$productZoomImages.on('lazyLoaded', initZoom);
		$productZoomImages.on('afterChange', initZoom);

		// Init main image carousel
		$productZoomImages.slick({
			vertical: true,
			arrows: false,
			verticalSwiping: true,
			asNavFor: $productZoomThumbnailsCarousel,
			lazyLoad: 'ondemand',
			initialSlide: targetSlide,
		});

		// Init thumbnails carousel
		$productZoomThumbnailsCarousel.slick({
			vertical: true,
			slidesToShow: 3,
			asNavFor: $productZoomImages,
			centerMode: true,
			focusOnSelect: true,
			initialSlide: targetSlide,
			prevArrow: $productZoom.find('.product-zoom__prev'),
			nextArrow: $productZoom.find('.product-zoom__next'),
		});

		// Handle close
		$productZoomClose.click(function () {
			// Close overlay + remove scroll lock from body
			$productZoom.removeClass(activeClass);
			$('body').removeClass(scrollLockClass);

			// Destroy slick
			$productZoomImages.slick('unslick');
			$productZoomThumbnailsCarousel.slick('unslick');
		});
	});

	$(window).on('scroll', function () {
		if ($(window).scrollTop() > $('#shopify-section-product').height() / 2) {
			$('.sticky-product-cart').addClass('sticky-visible');
			$('body').addClass('sticky-present');
		} else {
			$('.sticky-product-cart').removeClass('sticky-visible');
			$('body').removeClass('sticky-present');
		}
	});

  $('.collection-grid .hero.hero--advertisement').remove();

  $('.m_close_search').click(function(){
    $('.menu-icons__icon.menu-icons__icon--search').trigger('click');
  });
});
